import trans from './trans.json';

export type Lang = 'zh' | 'en';

type Entry = Record<Lang, string>;
const TABLE = trans as unknown as Record<string, Entry>;

/**
 * 多语言唯一入口。禁止在任何地方写 `if (lang === 'en')` 这类判断，
 * 所有文案都走 trans.json，一个 key 一条记录。
 */
export class Trans {
  private static lang: Lang = (localStorage.getItem('hip.lang') as Lang) || 'zh';

  static current(): Lang {
    return this.lang;
  }

  static set(lang: Lang): void {
    this.lang = lang;
    localStorage.setItem('hip.lang', lang);
  }

  static toggle(): Lang {
    this.set(this.lang === 'zh' ? 'en' : 'zh');
    return this.lang;
  }

  static t(key: string): string {
    const e = TABLE[key];
    return e ? e[this.lang] : key;
  }
}
